import { createAction } from '@reduxjs/toolkit';

export const POST_WRAPUP_ACTION_TYPE = 'saga/postWrapup';
export const postWrapupAction = createAction(POST_WRAPUP_ACTION_TYPE);
